import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import RoutesApp from '../../routes';

//Estilos
import './Layout.css';

//Componentes
import NavbarContainer from '../../components/navbar/NavbarContainer';
import Footer from '../../components/footer/Footer';

function Layout() {
    const token = window.sessionStorage.getItem('token');

    // if there is not token, redirect to the login page
    if (!token) {
        return <Navigate to={RoutesApp.Login} />;
    }

    return (
        <div className="layout-container">
            <NavbarContainer />
            <div className="layout-body">
                <Outlet />
            </div>
            <Footer />
        </div>
    );
}

export default Layout;
